<div class="main-content">
  <header>
    <app-desktop-header></app-desktop-header>
    <app-mobile-header></app-mobile-header>
  </header>
  <router-outlet></router-outlet>
</div>
<app-pwa-popup></app-pwa-popup>
@if ((authService.isAuthenticated() | async) === authState.Authenticated) {
  <app-global-search-overlay />
}
<app-footer></app-footer>
